// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YNA7LVeupfwkpXRVCove{visibility:hidden}.oqlH0caI8kQN8v9entfI{margin-bottom:2px}.oqlH0caI8kQN8v9entfI:hover .YNA7LVeupfwkpXRVCove{visibility:visible}.oqlH0caI8kQN8v9entfI.I6H9ELsy0B83qxWCNRs3{cursor:grab}.oqlH0caI8kQN8v9entfI.I6H9ELsy0B83qxWCNRs3:active{cursor:grabbing}.b_MlpYkIsTk7yy99QqNE .YNA7LVeupfwkpXRVCove{visibility:visible}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"moreButton": `YNA7LVeupfwkpXRVCove`,
	"segment": `oqlH0caI8kQN8v9entfI`,
	"draggable": `I6H9ELsy0B83qxWCNRs3`,
	"activeDropdown": `b_MlpYkIsTk7yy99QqNE`
};
export default ___CSS_LOADER_EXPORT___;
